<template>
  <div>
    <a href="#" v-b-modal="modalID">
      <i class="fa fa-eye"></i>
      View
    </a>

    <b-modal title="Categories" :id="modalID" :ref="modalID" no-close-on-esc no-close-on-backdrop hide-footer size="md">
      <ol>
        <li v-for="(cat, i) in categories" :key="i">
          {{ cat.name }}
          <ul>
            <li v-for="(subcat, j) in cat.subCategories" :key="j">{{ subcat.name }}</li>
          </ul>
        </li>
      </ol>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    modalID: String,
    categories: {
      type: Array,
    },
  },
  data() {
    return {
      //modalID: "viewCategories",
    };
  },
  methods: {},
};
</script>

<style>
</style>